
/**
 * Collection of translations which may be referenced and used within the shared project.
 *
 * Usage:
 *
 * import { APPTRANSLATIONS } from 'projects/shared/lib/i18n/translations';
 *
 * public appTranslations = APPTRANSLATIONS;
 *
 * <span>{{ appTranslations[name] }}</span>
 *
 * appTranslations.name
 *
 * These entries are mapped over to the project specific files which are used within their projects and may be extended with further entries.
 *
 * Extension example:
 *
 * import { APPTRANSLATIONS as APPTRANSLATIONSBASE } from 'projects/shared/lib/i18n/translations';
 *
 * export const APPTRANSLATIONS: { [key: string]: string } = {
 *
 * ...APPTRANSLATIONSBASE,
 *
 * name: $localize`:@@NameLabel:Name`
 *
 * }
 */
export const APPTRANSLATIONSCORE: { [key: string]: string } = {
  // insert shared i18n here.
};
